import utils from '@/mixins/utils'

export function filtro(
  cadastros,
  idade_inicial,
  idade_final,
  sexo,
  exibirVermelhos,
  exibirVerdes,
  groupFilter
) {
  let cadastros_filtrados = cadastros

  //busca pela faixa etária
  if (idade_inicial != '' && idade_final != '') {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      let ida = parseInt(item.idade)
      return ida >= idade_inicial && ida <= idade_final
    })
  }

  // busca pelo nome
  /*  if (nome != '') {
    cadastros_filtrados = cadastros_filtrados.filter(item => {
      return item.no_cidadao.toUpperCase().indexOf(nome.toUpperCase()) > -1
    })
  } */

  // busca pelo sexo
  if (sexo != '' && sexo != 'todos') {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      return item.sexo == sexo
    })
  }

  if (groupFilter != null) {
    cadastros_filtrados = handleGroupFilter(
      cadastros_filtrados,
      groupFilter.value
    )
  }

  if (exibirVermelhos === true) {
    if (cadastros_filtrados != undefined) {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (
          item.dias_fci_atualizada == null ||
          item.dias_fci_atualizada > 730 ||
          item.dias_fcdt_atualizada == null ||
          item.dias_fcdt_atualizada > 730
        ) {
          return true
        } else {
          return false
        }
      })
    }
  }

  if (exibirVerdes === true) {
    if (cadastros_filtrados != undefined) {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (
          item.dias_fci_atualizada != null &&
          item.dias_fci_atualizada < 730 &&
          item.dias_fcdt_atualizada != null &&
          item.dias_fcdt_atualizada < 730
        ) {
          return true
        } else {
          return false
        }
      })
    }
  }

  return cadastros_filtrados
}

export function handleGroupFilter(data, group) {
  if (data.length > 0) {
    let filtrado = data.filter((item) => {
      if (group === 'ativos') {
        return item.ativo_territorio == 1
      }
      // else if (group === 'simplificados') {
      //   return item.dt_ultima_ficha == null
      // }
      else if (group === 'obitos') {
        return item.st_faleceu == 1
      } else if (group === 'mudou-se') {
        return item.saiu == 2
      }
      // else if (group === 'atendimento-recente') {
      //   return item.atend_pos_saiu == 1
      // }
      else if (group === 'desatualizados') {
        return (
          item.saiu == 0 &&
          item.dias_fci_atualizada > 850 &&
          item.duplicado != 2
        )
      } else if (group === 'duplicados') {
        return item.duplicado == 2 && item.saiu == 0
      } else if (group === 'atualizacao-12') {
        return (
          ((item.dias_fci_atualizada != null &&
            item.dias_fci_atualizada > 365 &&
            item.dias_fci_atualizada < 730) ||
            (item.dias_fcdt_atualizada != null &&
              item.dias_fcdt_atualizada > 365 &&
              item.dias_fcdt_atualizada < 730)) &&
          item.saiu == 0
        )
      } else if (group === 'incompletos') {
        return (
          item.ativo_territorio == 1 &&
          (item.percent_fci_completa < 100 || item.percent_fcdt_completa < 100)
        )
      } else {
        return item
      }
    })
    return filtrado
  }
}
